'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import authService from '../src/services/auth.service';

export default function LoginPage() {
  const router = useRouter();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await authService.login(formData);
      console.log('Login successful:', response);
      // Redirect to dashboard on success
      router.push('/tour-types');
    } catch (err) {
      console.error('Login failed:', err);
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#1c1c1c] via-[#161616] to-[#0f0f0f] px-4 sm:px-6 lg:px-8">
      {/* Decorative background blur shapes */}
      <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-[#4f5a50]/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#0ab39c]/5 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-md w-full space-y-8 bg-[#222222]/80 backdrop-blur-xl p-8 sm:p-10 rounded-3xl shadow-2xl border border-white/5 relative z-10">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <img
              src="/logo.png"
              alt="Wild Northern Journey Logo"
              className="h-16 w-auto object-contain"
              onError={(e) => {
                e.target.src = "https://ui-avatars.com/api/?name=Wild+Northern&background=4f5a50&color=fff&bold=true&size=128";
              }}
            />
          </div>
          <h2 className="text-2xl font-bold text-white tracking-tight">Welcome Back</h2>
          <p className="mt-2 text-xs text-gray-400 uppercase tracking-widest font-semibold">
            Admin Panel Sign In
          </p>
        </div>

        <form className="mt-8 space-y-5" onSubmit={handleLogin}>
          {error && (
            <div className="bg-red-500/10 text-red-400 border border-red-500/20 p-4 rounded-xl text-xs flex items-center space-x-2.5 animate-in fade-in duration-200">
              <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="font-semibold">{error}</span>
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-xs font-bold uppercase tracking-wider text-gray-400">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="mt-2 block w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-sm shadow-inner text-white placeholder-gray-500
                focus:outline-none focus:ring-2 focus:ring-[#4f5a50] focus:border-transparent transition-all duration-200"
                placeholder="admin@wildnorthernjourney.com"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-xs font-bold uppercase tracking-wider text-gray-400">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={formData.password}
                onChange={handleChange}
                className="mt-2 block w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-sm shadow-inner text-white placeholder-gray-500
                focus:outline-none focus:ring-2 focus:ring-[#4f5a50] focus:border-transparent transition-all duration-200"
                placeholder="••••••••"
              />
            </div>
          </div>

          <div className="pt-2">
            <button
              type="submit"
              disabled={loading}
              className={`group relative w-full flex justify-center py-3.5 px-4 border border-transparent text-xs font-bold uppercase tracking-widest rounded-xl text-white 
              ${loading ? 'bg-[#4f5a50]/70 cursor-not-allowed' : 'bg-[#4f5a50] hover:bg-[#5e6b5f] hover:scale-[1.01] active:scale-[0.99]'} 
              transition-all duration-200 shadow-xl shadow-black/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#4f5a50]`}
            >
              {loading ? (
                <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              ) : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}